export const getSlidesPerView = ({ config, applicationSize, }) => {
    if (config === 'auto') {
        return config;
    }
    if (typeof config === 'number') {
        return config;
    }
    switch (applicationSize) {
        case 'large':
            return config.lg;
        case 'medium':
            return config.md;
        case 'small':
            return config.sm;
        default:
            return 'auto';
    }
};
